import type { IpgConfig, IpwConfig, MerchantConfig } from './backend_config.types';
import { MerchantWebsiteType, MerchantConfigSchema, RpaModuleName } from './backend_config.types';
import { IpgSystemId, IpwSystemId, IpgSystemIdKey, IpwSystemIdKey } from './types/third-party-system.enums';

export const ipgConfigValor: IpgConfig = {
    ipg_id: IpgSystemId.VALOR_US,
    name: 'Valor',
    urlPattern: 'https://*.valorpaytech.com/*',
    workflow_prefix: 'valor',
    allowedWebsites: [
        {
            type: MerchantWebsiteType.IPG,
            url: 'https://demo.valorpaytech.com',
            name: 'Valor Portal',
            allowedUrlPatterns: ['https://*.valorpaytech.com/*'],
            sessionPersistence: 'persistent',
        },
    ],
    rpaModules: [RpaModuleName.VALORPAYTECH_IPG],
};


export const ipwConfigPcpartpicker: IpwConfig = {
    ipw_id: IpwSystemId.PCPARTPICKER,
    ipw_system_id: IpwSystemIdKey.PCPARTPICKER,
    name: 'PCPartPicker',
    urlPattern: 'https://pcpartpicker.com/*',
    workflow_prefix: 'pcpartpicker',
    allowedWebsites: [
        {
            type: MerchantWebsiteType.IPW,
            url: 'https://pcpartpicker.com/list',
            name: 'PCPartPicker (Demo SOR)',
            allowedUrlPatterns: ['https://pcpartpicker.com/'],
            sessionPersistence: 'persistent',
        },
    ],
    rpaModules: [RpaModuleName.PCPARTPICKER_IPW],
};

export const ipwConfigDealertrack: IpwConfig = {
    ipw_id: IpwSystemId.DEALERTRACK,
    ipw_system_id: IpwSystemIdKey.DEALERTRACK,
    name: 'Dealertrack',
    urlPattern: 'https://*.coxautoinc.com/*',
    workflow_prefix: 'dealertrack',
    allowedWebsites: [
        {
            type: MerchantWebsiteType.IPW,
            url: 'https://signin.coxautoinc.com/',
            name: 'Dealertrack',
            allowedUrlPatterns: ['https://*.coxautoinc.com/*'],
            sessionPersistence: 'persistent',
        },
    ],
    rpaModules: [RpaModuleName.DEALERTRACK_IPW],
    reconciliation: {
        paymentCode: 'AB',
        doInjectApprovalNumber: false,
        doFinalizeReconciliation: false,
    },
};

export const defaultIpgConfigByKey: Record<IpgSystemIdKey, IpgConfig> = {
    [IpgSystemIdKey.VALOR_US]: ipgConfigValor,
};

export const defaultIpwConfigByKey: Record<IpwSystemIdKey, IpwConfig> = {
    [IpwSystemIdKey.PCPARTPICKER]: ipwConfigPcpartpicker,
    [IpwSystemIdKey.DEALERTRACK]: ipwConfigDealertrack,
};

export const defaultIpgConfigById: Record<IpgSystemId, IpgConfig> = {
    [IpgSystemId.VALOR_US]: ipgConfigValor,
};

export const defaultIpwConfigById: Record<IpwSystemId, IpwConfig> = {
    [IpwSystemId.PCPARTPICKER]: ipwConfigPcpartpicker,
    [IpwSystemId.DEALERTRACK]: ipwConfigDealertrack,
};

export const defaultMerchantConfig: MerchantConfig = MerchantConfigSchema.parse({
    ipg: defaultIpgConfigByKey,
    ipw: defaultIpwConfigByKey,
});
